import SideBar from '@/components/SidebarPlugin';
import GlobalDirectives from './globalDirectives';
import RTLPlugin from './RTLPlugin';

//css assets
import '@/assets/sass/black-dashboard.scss';
import '@/assets/css/nucleo-icons.css';
import '@/assets/demo/demo.css';

export default {
    install(app) {
        app.use(GlobalDirectives);
        app.use(SideBar);
        app.use(RTLPlugin);
    },
};
